(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["quick-view"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function getOverlay() {
    let overlay = document.getElementById('qv-overlay');
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.id = 'qv-overlay';
    overlay.className = 'qv-overlay';
    overlay.innerHTML = `
      <div class="qv-modal">
        <button class="qv-modal__close" aria-label="Close">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3 3L13 13M13 3L3 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
        <div class="qv-modal__inner">
          <div class="qv-modal__spinner"></div>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    overlay.querySelector('.qv-modal__close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    return overlay;
  }

  function close() {
    const overlay = document.getElementById('qv-overlay');
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!overlay.classList.contains('is-open')) {
        overlay.querySelector('.qv-modal__inner').innerHTML = '<div class="qv-modal__spinner"></div>';
      }
    }, 300);
  }

  function open(handle, productUrl) {
    const overlay = getOverlay();
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        renderModal(overlay.querySelector('.qv-modal__inner'), product, productUrl);
      })
      .catch(function () {
        overlay.querySelector('.qv-modal__inner').innerHTML = '<p style="padding:40px;text-align:center">Could not load product.</p>';
      });
  }

  function renderModal(container, product, productUrl) {
    const variant = product.variants[0];
    const image = product.images[0] || '';
    const hasMultipleVariants = product.variants.length > 1;
    const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

    let variantsHtml = '';
    if (hasMultipleVariants) {
      const optionSelects = product.options_with_values.map(function (option) {
        const opts = option.values.map(function (v) {
          return '<option value="' + v + '">' + v + '</option>';
        }).join('');
        return '<div class="qv-modal__variants"><label>' + option.name + '</label><select data-option="' + option.position + '">' + opts + '</select></div>';
      }).join('');
      variantsHtml = optionSelects;
    }

    const priceHtml = onSale
      ? '<s>' + formatMoney(variant.compare_at_price) + '</s> <span class="qv-modal__price-sale">' + formatMoney(variant.price) + '</span>'
      : formatMoney(variant.price);

    container.innerHTML = `
      ${image ? '<img class="qv-modal__image" src="' + image + '" alt="' + product.title + '">' : ''}
      ${product.vendor ? '<div class="qv-modal__vendor">' + product.vendor + '</div>' : ''}
      <h2 class="qv-modal__title">' + product.title + '</h2>
      <div class="qv-modal__price">${priceHtml}</div>
      ${variantsHtml}
      <hr class="qv-modal__divider">
      <button class="qv-modal__atc" data-variant-id="${variant.id}" ${variant.available ? '' : 'disabled'}>
        ${variant.available ? 'إضافة إلى السلة' : 'نفذ المخزون'}
      </button>
      <a href="${productUrl}" class="qv-modal__view-link">اشتر الآن</a>
    `;

    // Replace the broken title concatenation
    container.querySelector('.qv-modal__title').textContent = product.title;

    // Variant switching
    container.querySelectorAll('select[data-option]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        const selected = [];
        container.querySelectorAll('select[data-option]').forEach(function (s) {
          selected[parseInt(s.dataset.option) - 1] = s.value;
        });
        const matched = product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        });
        if (matched) {
          updateVariant(container, matched);
        }
      });
    });

    // Add to cart
    container.querySelector('.qv-modal__atc').addEventListener('click', function () {
      const btn = this;
      const id = parseInt(btn.dataset.variantId);
      btn.disabled = true;
      btn.textContent = '...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = '✓ تمت الإضافة';
        setTimeout(function () {
          close();
          // Trigger cart update if your theme uses a custom event
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }, 1200);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'إضافة إلى السلة';
      });
    });
  }

  function updateVariant(container, variant) {
    const btn = container.querySelector('.qv-modal__atc');
    btn.dataset.variantId = variant.id;
    btn.disabled = !variant.available;
    btn.textContent = variant.available ? 'إضافة إلى السلة' : 'نفذ المخزون';

    const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    const priceEl = container.querySelector('.qv-modal__price');
    priceEl.innerHTML = onSale
      ? '<s>' + formatMoney(variant.compare_at_price) + '</s> <span class="qv-modal__price-sale">' + formatMoney(variant.price) + '</span>'
      : formatMoney(variant.price);
  }

  function formatMoney(cents) {
    return 'EGP ' + (cents / 100).toFixed(2);
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.quick-view-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open(btn.dataset.productHandle, btn.dataset.productUrl);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    (function () {
  function initSwatchNav(wrapperEl) {
    var productId = wrapperEl.dataset.productId;
    var swatchesEl = wrapperEl.querySelector('product-swatches[data-product-id="' + productId + '"]');
    if (!swatchesEl) return;

    var prevBtn = wrapperEl.querySelector('.swatches-carousel-nav__btn--prev');
    var nextBtn = wrapperEl.querySelector('.swatches-carousel-nav__btn--next');

    function getScrollList() {
      var overflowList = swatchesEl.querySelector('overflow-list');
      if (!overflowList) return null;
      // Try shadow DOM first, fall back to light DOM part
      if (overflowList.shadowRoot) {
        return overflowList.shadowRoot.querySelector('[part="list"]');
      }
      return overflowList.querySelector('[part="list"]');
    }

    function updateButtons(list) {
      if (!list) return;
      prevBtn.disabled = list.scrollLeft <= 4;
      nextBtn.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 4;
    }

    function scroll(direction) {
      var list = getScrollList();
      if (!list) return;
      var itemWidth = list.querySelector('*') ? list.querySelector('*').offsetWidth + 8 : 40;
      var scrollAmount = itemWidth * 3;
      list.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
      setTimeout(function () { updateButtons(list); }, 350);
    }

    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      scroll(-1);
    });

    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      scroll(1);
    });

    // Poll briefly until overflow-list is ready
    var attempts = 0;
    var interval = setInterval(function () {
      var list = getScrollList();
      attempts++;
      if (list || attempts > 20) {
        clearInterval(interval);
        if (list) {
          updateButtons(list);
          list.addEventListener('scroll', function () { updateButtons(list); }, { passive: true });
        }
      }
    }, 100);
  }

  function initAll() {
    document.querySelectorAll('.swatches-carousel-wrapper').forEach(initSwatchNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
